import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46ad1d23"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  align: "center",
  class: "mt-4"
}
const _hoisted_2 = {
  key: 0,
  align: "center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-h6 font-weight-bold mb-4" }
const _hoisted_5 = { align: "center" }
const _hoisted_6 = {
  align: "center",
  class: "mt-2"
}
const _hoisted_7 = {
  align: "end",
  class: "mt-15"
}

import { useI18n } from 'vue-i18n'
import { ref, onMounted, computed, Ref } from 'vue'
import { RequestResponse, Subscriber } from '@/types'
import { broadcastingActions } from '@/stores/broadcasting-store'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentTable',
  setup(__props) {

const subscribers = ref<Subscriber[]>([])

const loading = ref(false)
const { t } = useI18n()
const broadcasting = broadcastingActions()

const page = ref(1)
const itemsPerPage = ref(5)
const requestResponse = ref<RequestResponse>()
const removing = ref(false)
const removingId = ref<string>('')
const removingName = ref<string>('')
const removingPhoto = ref<string>('')
const headers = computed(() => {
  return [
    {
      title: 'Photo',

      key: 'photo',
      sortable: false,
      align: 'center',
    },
    { title: t('table.name'), key: 'name', sortable: false, align: 'center' },
    { title: t('city'), key: 'city', sortable: false, align: 'center' },
    { title: t('table.uni'), key: 'uni', sortable: false, align: 'center' },

    {
      title: t('table.remove'),
      key: 'action',
      sortable: false,
      align: 'center',
    },
  ]
})

onMounted(() => {
  loadSubscribers()
})

const loadSubscribers = async () => {
  loading.value = true

  const response = await broadcasting.getSubscribers(
    page.value,
    itemsPerPage.value
  )

  requestResponse.value = response

  if (response.success) {
    subscribers.value = response.result as Subscriber[]
  }
  loading.value = false
}

const applicantsArray = computed((): any => {
  const array: any[] = []

  subscribers.value.forEach((applicant) => {
    const singleSubscriber = {
      id: applicant._id,
      photo: applicant.userProfile,
      name:
        applicant.userInfo?.firstName ??
        '' + ' ' + applicant.userInfo?.lastName ??
        '',
      uni: applicant.userInfo.university,
      city: applicant.userInfo.city,
    }
    array.push(singleSubscriber)
  })

  return array
})
const remove = (subscriber: any) => {
  removingId.value = subscriber.id
  removingName.value = subscriber.name
  removingPhoto.value = subscriber.photo
  removing.value = true
}
const removeSubscriber = async (id: string) => {
  loading.value = true
  const body = {
    connectionId: id,
    status: 'REMOVE',
  }
  await broadcasting.removeSubscriber(body)
  removing.value = false

  loadSubscribers()

  setTimeout(() => {
    loadSubscribers()
    loading.value = false
  }, 200)
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('your-subscribers')), 1),
    _createVNode(_component_v_divider, { class: "mt-3" }),
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_request_status, {
          key: 0,
          response: requestResponse.value
        }, null, 8, ["response"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_data_table, {
      style: {"margin-top":"9px"},
      "items-per-page": itemsPerPage.value,
      "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((itemsPerPage).value = $event)),
      headers: headers.value,
      items: applicantsArray.value
    }, {
      [`item.photo`]: _withCtx((props) => [
        (props.item.photo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_img, _mergeProps({
                src: props.item.photo,
                alt: "student Image"
              }, props, {
                class: "image mb-2",
                referrerpolicy: "no-referrer",
                rel: "noreferrer"
              }), null, 16, ["src"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_img, _mergeProps(props, {
                src: require('../../../../../assets/stud-team1.png'),
                alt: "student Image",
                class: "image mb-2",
                referrerpolicy: "no-referrer",
                rel: "noreferrer"
              }), null, 16, ["src"])
            ]))
      ]),
      [`item.action`]: _withCtx((props) => [
        _createVNode(_component_v_btn, _mergeProps(props, {
          color: "#3fb984",
          onClick: ($event: any) => (remove(props.item))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "mr-2" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-trash-can")
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('table.remove')), 1)
          ]),
          _: 2
        }, 1040, ["onClick"])
      ]),
      _: 2
    }, 1032, ["items-per-page", "headers", "items"]),
    _createVNode(_component_v_dialog, {
      modelValue: removing.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((removing).value = $event)),
      "max-width": "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, {
          border: "md",
          class: "pa-6 text-black mx-auto",
          color: "white",
          "min-width": "350px",
          style: {"border-radius":"7%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('remove-subscriber')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(removingName.value), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_img, {
                src: removingPhoto.value,
                width: "70px",
                style: {"border-radius":"50%"},
                lazy: ""
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                color: "error",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (removing.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('go-back')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                class: "ml-2",
                color: "#3fb984",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (removeSubscriber(removingId.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('table.remove')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})